import React from "react";
import { Container } from "@mui/material";
import DashboardHeader from "./dashboard-header";

const DashBoardContainer = ({ children }) => {
  return (
    <>
      <DashboardHeader />
      <Container sx={{ marginBottom: "50px" }}>{children}</Container>
    </>
  );
};

DashBoardContainer.propTypes = {};

export default DashBoardContainer;
